import azureLogo from 'images/logos/azure-devops.svg';
import bitbucketLogo from 'images/logos/bitbucket-logo.svg';
import githubLogo from 'images/logos/github-logo.svg';
import gitlabLogo from 'images/logos/gitlab-logo.svg';
import googleLogo from 'images/logos/google-logo.svg';
import slackLogo from 'images/logos/slack-logo.svg';
import pick from 'lodash/pick';

export const OAuthProviders = {
  google: {
    logo: googleLogo,
    authIdentity: 'google',
    title: 'google',
    isLogin: true
  },
  github: {
    logo: githubLogo,
    authIdentity: 'github',
    title: 'github',
    isLogin: true
  },
  slack: {
    logo: slackLogo,
    authIdentity: 'slack',
    title: 'slack',
    isLogin: true
  },
  bitbucket: {
    logo: bitbucketLogo,
    authIdentity: 'bitbucket',
    title: 'bitbucket',
    isLogin: true
  },
  gitlab: {
    logo: gitlabLogo,
    authIdentity: 'gitlab',
    title: 'gitlab',
    isLogin: true
  },
  azure_devops: {
    authIdentity: 'azure',
    title: 'azure',
    isLogin: true,
    logo: azureLogo
  }
};

export const registerProvidersTeam = () =>
  pick(OAuthProviders, ['github', 'bitbucket', 'gitlab', 'azure_devops']);

export const registerProvidersPaid = () =>
  pick(OAuthProviders, [
    'google',
    'github',
    'slack',
    'bitbucket',
    'gitlab',
    'azure_devops'
  ]);

